export default __webpack_public_path__ + "static/media/MV.5abac2c6.svg";